var map = {
	"./blackwhite.png": 2626,
	"./brownie.png": 1176,
	"./grayscale.png": 5889,
	"./invert.png": 8629,
	"./kodachrome.png": 9785,
	"./polaroid.png": 8360,
	"./sepia.png": 2884,
	"./technicolor.png": 4195,
	"./untitled folder/blackwhite.png": 960,
	"./untitled folder/brownie.png": 3153,
	"./untitled folder/grayscale.png": 2038,
	"./untitled folder/images-2021-12-09T07_30_39.zip": 622,
	"./untitled folder/invert.png": 1462,
	"./untitled folder/kodachrome.png": 5706,
	"./untitled folder/polaroid.png": 9397,
	"./untitled folder/sepia.png": 3202,
	"./untitled folder/technicolor.png": 6882,
	"./untitled folder/vintage.png": 1879,
	"./vintage.png": 1897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3742;